import { SUBSCRIPTION_PLANS } from 'app/hooks/useSubscriptionPlans/subscriptionPlansData';
import {
  buildDerivedFields,
  normalizeSubscriptionPaymentMethod,
} from './subscriptionStatus';

const resolvePlanType = (gatewayId) => {
  if (gatewayId == null) {
    return null;
  }

  const match = SUBSCRIPTION_PLANS.find(
    (plan) => String(plan.gateway_id) === String(gatewayId),
  );

  return match?.plan_type ?? null;
};

export const mapJusbillSubscription = (data) => {
  const { subscription } = data;
  const amountInCents = subscription.plan?.amount ?? null;
  const amount = amountInCents != null ? amountInCents / 100 : null;
  const paymentMethod = normalizeSubscriptionPaymentMethod(
    subscription.payment_method,
  );
  const { next_charge_date, ...derivedStatus } = buildDerivedFields({
    rawStatus: subscription.status,
    currentPeriodEnd: subscription.current_period_end,
    paymentMethod,
  });

  return {
    success: true,
    client_id: data.client_id,
    id_client_jussub: null,
    plan_details: {
      name: subscription.plan?.name ?? null,
      amount,
      periodicity: subscription.plan?.days ?? null,
      gateway_id: subscription.plan?.id ?? null,
      plan_type: resolvePlanType(subscription.plan?.id),
    },
    info: {
      status: subscription.status,
      plan: subscription.plan?.name ?? null,
      plan_amount: amount,
      charged_amount: null,
      current_period_start: subscription.current_period_start,
      current_period_end: subscription.current_period_end,
      payment_method: paymentMethod,
      coupon: null,
      provider: subscription.provider,
      latest_update: subscription.date_updated,
      subscription_id: subscription.id,
      card_brand: subscription.card?.brand ?? null,
      card_last_digits: subscription.card?.last_digits ?? null,
      reason: subscription.reason ?? null,
      tickets: subscription.tickets ?? [],
      next_charge_date,
    },
    ...derivedStatus,
  };
};
